module.exports = __webpack_public_path__ + "img/data_economy.mars.bef6580.png";